import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBS: CultureInfo = {
  name: 'es-BS',
  displayName: 'español (Bahamas)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BS',
  parent: CultureInfoEs
};
